// extracted by mini-css-extract-plugin
var _1 = "FormFieldsPreview-moduleloader__XpMUi IconNG-moduleiconContainer__SxWZ0";
var _2 = "FormFieldsPreview-modulenavButton__CrIeD NavArrowButton-moduleNavArrowButton__PbEBW Button-modulebutton__AisLs Flat-moduleflat__s3eC8";
var _3 = "FormFieldsPreview-modulenavButtonLeft__VyPMd";
var _4 = "FormFieldsPreview-modulenavButtonRight__VhR1u";
var _5 = "FormFieldsPreview-modulepdfViewer__IcaSl";
var _6 = "FormFieldsPreview-modulepreviewPanel__xb3lS";
var _7 = "FormFieldsPreview-moduleuploadButtonWrapper__vgaYi";
var _8 = "FormFieldsPreview-moduleuploadPlaceholder___USMX";
var _9 = "FormFieldsPreview-moduleuploadPlaceholderText__r1Rv9";
export { _1 as "loader", _2 as "navButton", _3 as "navButtonLeft", _4 as "navButtonRight", _5 as "pdfViewer", _6 as "previewPanel", _7 as "uploadButtonWrapper", _8 as "uploadPlaceholder", _9 as "uploadPlaceholderText" }
